import React from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';
import {
  Button,
  Container,
  FormikWrapper,
  FormTextField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { ROUTE_ACCOUNT_REGISTER } from '../../config/routes';
import { API_URL } from '../../config/constants';

import './style.scss';

export interface MemberWallProps { }

const MemberWall: React.FC<MemberWallProps> = () => {
  const { t } = useTranslation();
  const path = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['router', 'location', 'pathname']));

  const SignupSchema = Yup.object().shape({
    email: Yup.string().email(t('validation_messages.member_wall.email')).required(t('validation_messages.member_wall.email')),
  });

  return (
    <>
      <div className="MemberWallOverlay">
        <div className="MemberWallOverlay__head" />
      </div>
      {/* <div className="MemberWall__head" /> */}
      <div className="MemberWallContainer">
        <Container>
          <div className="row">
            <div className="col-12 col-lg-10 offset-lg-1">
              <div className="MemberWall">
                <div className="MemberWall__body">
                  <div className="MemberWall__body__iconWrapper">
                    <i className="icon icon-lock-thin" />
                  </div>
                  <div className="MemberWall__body__title">
                    <span>{t('member_wall.title')}</span>
                  </div>
                  <div className="MemberWall__body__subtitle">
                    <span>{t('member_wall.subtitle')}</span>
                  </div>
                  <FormikWrapper
                    validationSchema={SignupSchema}
                    onSubmit={(values: any) => {
                      // This endpoint redirects user to the login or register page.
                      // Because the endpoint redirects we can't use a history push for this.
                      const url = `${API_URL}/member_content_redirect?email=${encodeURIComponent(values.email)}&destination=${encodeURIComponent(path)}`;
                      window.location.href = url;
                    }}
                  >
                    <FormTextField
                      fieldName="email"
                      placeholder={t('form.email_label')}
                      required
                    />
                    <Button type="submit">
                      {t('general.continue')}
                      <i className="icon icon-arrow-right" />
                    </Button>
                  </FormikWrapper>
                </div>
              </div>
            </div>
          </div>
        </Container>
        <div className="spacer" />
      </div>
    </>
  );
};

export default MemberWall;
